module.exports = __webpack_public_path__ + "img/silver2.614befbc.png";